/**
 * Scrolls to a section id on the one-page home layout (fixed header offset).
 */
export function scrollHomeSectionIntoView(id) {
  if (!id) return;
  const element = document.getElementById(id);
  if (!element) return;
  const offset = 90;
  const y = element.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}

export const HOME_SCROLL_TARGET_KEY = 'wsj-home-scroll-target';
